import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { PopoverItem } from 'site-modules/shared/components/popover-item/popover-item';

import './vdp-popover-item.scss';

export const VdpPopoverItem = ({
  className = 'text-gray-darker tooltip-sup-override',
  placement = 'bottom',
  iconClassName = 'px-0_25 pt-0_5 pb-0 p-md-0',
  screenReaderTooltipLabel = '',
  tooltip,
  children,
  innerClassName,
  ...props
}) => {
  if (!tooltip && !children) {
    return null;
  }

  return (
    <PopoverItem
      placement={placement}
      className={classNames('vdp-popover-item', className)}
      iconClassName={iconClassName}
      screenReaderTooltipLabel={screenReaderTooltipLabel}
      innerClassName={classNames('vdp-popover-inner', innerClassName)}
      {...props}
    >
      {children || tooltip}
    </PopoverItem>
  );
};

VdpPopoverItem.propTypes = {
  placement: PropTypes.string,
  iconClassName: PropTypes.string,
  className: PropTypes.string,
  screenReaderTooltipLabel: PropTypes.string,
  innerClassName: PropTypes.string,
  tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node]),
};
